(function () {
  var DISMISS_TTL_MS = 24 * 60 * 60 * 1000; // re-show the banner after 1 day

  function applyDiscount(code) {
    // Hitting /discount/{code} sets Shopify's discount session cookie as a
    // side effect of the request — it normally 302-redirects the browser,
    // but a fetch() just follows that redirect internally and never
    // navigates the page, so the code gets applied silently in the
    // background.
    var url = '/discount/' + encodeURIComponent(code) + '?redirect=/';
    return fetch(url, { credentials: 'same-origin' }).catch(function () {
      // Best-effort — still show the success overlay even if this fails.
    });
  }

  function init() {
    document.querySelectorAll('[data-coupon-widget]').forEach(function (widget) {
      // Dismissed earlier — stay hidden until DISMISS_TTL_MS has passed
      // since that dismissal, not forever.
      var dismissKey = widget.getAttribute('data-storage-key');
      if (dismissKey) {
        var dismissedAt = Number(localStorage.getItem(dismissKey));
        if (dismissedAt && Date.now() - dismissedAt < DISMISS_TTL_MS) {
          widget.hidden = true;
          return;
        }
        if (dismissedAt) localStorage.removeItem(dismissKey);
      }

      var closeButton = widget.querySelector('[data-coupon-close]');
      if (closeButton) {
        closeButton.addEventListener('click', function (event) {
          event.stopPropagation();
          widget.hidden = true;
          if (dismissKey) localStorage.setItem(dismissKey, String(Date.now()));
        });
      }

      var badge = widget.querySelector('[data-coupon-trigger]');
      if (!badge) return;

      var overlay = badge.querySelector('[data-coupon-overlay]');
      var messageEl = badge.querySelector('[data-coupon-message]');
      var code = badge.getAttribute('data-coupon-code');
      var message = badge.getAttribute('data-success-message');
      var storageKey = badge.getAttribute('data-storage-key');
      var applied = false;

      function reveal() {
        if (messageEl && message) messageEl.textContent = message;
        if (overlay) overlay.hidden = false;
      }

      // Already applied earlier this session — show the overlay without
      // re-hitting /discount, but clicking again still re-copies the code.
      if (storageKey && sessionStorage.getItem(storageKey) === '1') {
        applied = true;
        reveal();
      }

      badge.addEventListener('click', function () {
        var afterApply = !applied && code ? applyDiscount(code) : Promise.resolve();

        afterApply.then(function () {
          applied = true;
          if (storageKey) sessionStorage.setItem(storageKey, '1');
          reveal();

          if (code && navigator.clipboard) {
            navigator.clipboard.writeText(code).catch(function () {
              // Ignore — clipboard access can be blocked by the browser;
              // the coupon is still applied in the background regardless.
            });
          }
        });
      });

      badge.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          badge.click();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
